import React from 'react';
import { useIncrementalRendering } from '@/hooks';
import DataTableRow from '@/util/DataTableRow';
import DataTable from '@/util/DataTable';
import { CellsRenderer } from './CellsRenderer';

export type RowsRendererProps = {
  rows: DataTableRow[];
  dataTable: DataTable;
  getChartOption: any; // TODO: infer type.
};

export const RowsRenderer: React.FC<RowsRendererProps> = ({
  rows,
  getChartOption,
  dataTable,
}) => {
  const toRender = useIncrementalRendering(rows.length, 5, 100);

  return (
    <>
      {rows.slice(0, toRender).map((r, i) => (
        <tr key={i}>
          <CellsRenderer
            cells={r.cells()}
            getChartOption={getChartOption}
            dataTable={dataTable}
          />
        </tr>
      ))}
    </>
  );
};
